import numberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { connect } from "react-redux";

export default connect(state => ({
  value: state.membershipDetails.statistics.newMembers.newMembers,
  url: state.membershipDetails.statistics.newMembers.newMembersRawDataLink,
  disableAnimation: state.membershipDetails.currentUser.qa,
  toolTipId: "membershipDetailsNewMembers",
  toolTipContent: state.membershipDetails.statistics.newMembers.tooltip
}))(numberDisplay);
